import { Navigate } from "react-router-dom";

import { NETWORK_PATH, NETWORK_ROUTE_SEGMENTS } from "../../shared/routing/paths/network";
import {
  BuyerDetailsPage,
  BuyerNetworkRoute,
  BuyerProductRequestsOverviewPage,
  ConnectionDetailPage,
  ConnectionsPage,
  NetworkLandingPage,
  NetworkLandingRoute,
  ProductRequestsPage,
  SupplierConnectionsPage,
  SupplierNetworkRoute,
} from "./route-elements";
import { SupplierForwardRoutes } from "./supplier/forward-routes";
import { SupplierPublicRoutes } from "./supplier/public-routes";
import { SupplierSelectAccountRoutes } from "./supplier/select-account-routes";

// The supplier front door brings its own shell, so app mounts it outside AppLayout: nesting it there
// would mount a second AppShell, and with it a second Frontegg auth gate.
//
//   /network/supplier/register         public: an invited supplier registers
//   /network/supplier/forward-invite   public: forward the invite to a colleague
//   /network/supplier/select-account   authenticated, but behind its own AppShell,
//                                      so the real gate runs (AIM-2632)
export const SupplierFrontDoorRoutes = [SupplierPublicRoutes, SupplierForwardRoutes, SupplierSelectAccountRoutes];

// The breadcrumb trail is the chain of matched routes carrying a `crumb`, so detail routes are
// nested under their list route (not flat siblings) — that nesting is what puts the list crumb in
// the detail's trail. The name-bearing detail routes omit `crumb` — their dynamic leaf comes from
// useSetCrumbTitle.
export const NetworkRoutes = {
  path: NETWORK_ROUTE_SEGMENTS.root,
  handle: { crumb: "Network" },
  children: [
    {
      element: <NetworkLandingRoute />,
      children: [
        {
          index: true,
          element: <NetworkLandingPage />,
        },
      ],
    },
    {
      element: <BuyerNetworkRoute />,
      children: [
        {
          path: NETWORK_ROUTE_SEGMENTS.connections,
          handle: { crumb: "Suppliers" },
          children: [
            {
              index: true,
              element: <ConnectionsPage />,
            },
            {
              path: NETWORK_ROUTE_SEGMENTS.connectionId,
              element: <ConnectionDetailPage />,
            },
          ],
        },
        {
          path: NETWORK_ROUTE_SEGMENTS.productRequests,
          handle: { crumb: "Product requests" },
          children: [
            {
              index: true,
              element: <ProductRequestsPage />,
            },
          ],
        },
      ],
    },
    {
      // The authenticated part of `/network/supplier`. The public front door — `/register` and
      // `/forward-invite` — is not here: see `supplier/public-routes.tsx` and
      // `supplier/forward-routes.tsx`, both mounted outside AppLayout.
      path: NETWORK_ROUTE_SEGMENTS.supplier,
      element: <SupplierNetworkRoute />,
      children: [
        {
          index: true,
          element: <Navigate to={NETWORK_PATH} replace />,
        },
        {
          path: NETWORK_ROUTE_SEGMENTS.connections,
          handle: { crumb: "Buyers" },
          children: [
            {
              index: true,
              element: <SupplierConnectionsPage />,
            },
            {
              path: NETWORK_ROUTE_SEGMENTS.connectionId,
              element: <BuyerDetailsPage />,
            },
          ],
        },
        {
          path: NETWORK_ROUTE_SEGMENTS.productRequests,
          handle: { crumb: "Buyer product requests" },
          element: <BuyerProductRequestsOverviewPage />,
        },
      ],
    },
  ],
};
